import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-link-to-brand-variables',
  templateUrl: './link-to-brand-variables.component.html',
  styleUrls: ['./link-to-brand-variables.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LinkToBrandVariablesComponent {
  @Input() isBrandSettingsValueApplied: boolean;
  @Input() isDefaultValue: boolean;
  @Input() brandSettingsValue: any;
  @Input() disabled: boolean;
  @Input() customClass: string;
  @Output() apply = new EventEmitter();
  @Input() separateLogicForMobileAndDesktop: boolean;
  @Input() isAppliedToBoth: boolean;
  @Input() isAppliedToMobile: boolean;
  @Input() isAppliedToDesktop: boolean;
  @Input() canApplyBrandToMobile: boolean;

  constructor() {}

  public applyBrandSettings() {
    this.apply.emit();
  }
}
